import { Box } from "@mui/material"
import { CODIGO_SERVICO } from "src/components/projetos/acoes/alterarServico/ModalAlterarServico"
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple"

interface SelectCodigoServicoProps {
  codigoServico: string | undefined;
  onChangeCodigoServico: (value: string | undefined) => void;
  error?: boolean;
  helperText?: string
}

function SelectCodigoServico({ codigoServico, onChangeCodigoServico, error = false, helperText = '' }: SelectCodigoServicoProps) {
  return (
    <Box className={'L12'} style={{ padding: 0, position: "relative" }}>
      <InputSelectSimple
        name="codigo_servico"
        label="* Código do serviço"
        error={error}
        helperText={helperText}
        list={CODIGO_SERVICO}
        value={codigoServico || 0}
        onChange={(value: any) => {
          onChangeCodigoServico(value || "");
        }}
      />
    </Box>
  )
}

export { SelectCodigoServico }